import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();
  const navigate = useNavigate();

  // We have made a request to the API backend, but the user is not authenticated.
  // Redirect the user to the login.
  if (isRouteErrorResponse(error) && error.status === 401) {
    navigate("/");
  }

  return (
    <div>
      <h2>{t('errors.routeTitle')}</h2>
    </div>
  )
}
